import React from 'react'
import { Row, Col, Button } from "reactstrap";

// labels
import { LB_WIXLIST, NEW } from "../../i18n/i18n";

const WishlistHeader = ({
    title,
    showButton= true,
    onClick = () => console.warn('With out function')
}) => <Row className={'mb-2em'}>
    <Col>
        <h2>{`${LB_WIXLIST} ${title}`}</h2>
    </Col>
    {
        showButton && <Col>
            <div className="d-flex align-items-center">
                <div className="ml-auto paddingAdd">
                    <Button type="button" className="btn-add ml-auto" onClick={onClick}>
                        {NEW} <i className="fas fa-plus-circle btn-icon"/>
                    </Button>
                </div>
            </div>
        </Col>
    }
</Row>

export default WishlistHeader